module.exports = __webpack_public_path__ + "static/media/DSC09522_20180710_037-7.7df88634.jpg";